import Error from '../common/errorData'
import CON from '../constant'
// import handleAjax from '../common/handleajax';
// import catchFn from '../common/catch';
import {
  http
} from './index'
const pasurl = CON.URL_DOWN

const getReq = (url, data) => { // 封装get参数
  const urls = http.adornUrl(url, pasurl)
  return http.get(urls, {
    params: data
  })
}
export default {
  getTenant: (data) => getReq('/pc-api/cms/tenant/getTenant', data).then(Error)
}
